import { GET_LIST } from 'react-admin';
import { sortBy } from 'lodash';

import { getDomesticCountryCode } from 'services/helpers/countryCode';

export default {
  [GET_LIST]: ({ response }) => ({
    ...response,
    json: sortBy(response.json, [
      (item) => item.code !== getDomesticCountryCode(),
      (item) => item.name,
    ]),
  }),
};
